import { DefaultFilter } from './default-filter/default-filter.component';
import { LookupsComponent } from './lookups.component';
import { YtNgFrameworkModule, ModalService } from 'yt-ng-framework';
import { DrzavaUpdateComponent } from './drzava/drzava-update.component';
import { DrzavaModalUpdateComponent } from './drzava/drzava-modal-update.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RobaComponent } from './roba/roba.component';
import { RobaModalUpdateComponent } from './roba/roba-modal-update.component';
import { RobaUpdateComponent } from './roba/roba-update.component';
import { JedinicaMereComponent } from './jedinica-mere/jedinica-mere.component';
import { JedinicaMereUpdateComponent } from './jedinica-mere/jedinica-mere-update.component';
import { JedinicaMereModalUpdateComponent } from './jedinica-mere/jedinica-mere-modal-update.component';
import { KomitentComponent } from './komitent/komitent.component';
import { KomitentUpdateComponent } from './komitent/komitent-update.component';
import { KomitentModalUpdateComponent } from './komitent/komitent-modal-update.component';
import { KomitentTabsComponent } from './komitent/komitent-tabs.component';
import { KomitentTabUpdateComponent } from './komitent/komitent-tab-update.component';
import { MagacinComponent } from './magacin/magacin.component';
import { MagacinUpdateComponent } from './magacin/magacin-update.component';
import { MagacinModalUpdateComponent } from './magacin/magacin-modal-update.component';
import { MestoComponent } from './mesto/mesto.component';
import { MestoUpdateComponent } from './mesto/mesto-update.component';
import { MestoModalUpdateComponent } from './mesto/mesto-modal-update.component';
import { OkrugComponent } from './okrug/okrug.component';
import { OkrugModalUpdateComponent } from './okrug/okrug-modal-update.component';
import { OkrugUpdateComponent } from './okrug/okrug-update.component';
import { OpstinaComponent } from './opstina/opstina.component';
import { OpstinaModalUpdateComponent } from './opstina/opstina-modal-update.component';
import { OpstinaUpdateComponent } from './opstina/opstina-update.component';
import { TipKomitentaComponent } from './tip-komitenta/tip-komitenta.component';
import { TipKomitentaModalUpdateComponent } from './tip-komitenta/tip-komitenta-modal-update.component';
import { TipKomitentaUpdateComponent } from './tip-komitenta/tip-komitenta-update.component';
import { VrstaKomitentaComponent } from './vrsta-komitenta/vrsta-komitenta.component';
import { VrstaKomitentaModalUpdateComponent } from './vrsta-komitenta/vrsta-komitenta-modal-update.component';
import { VrstaKomitentaUpdateComponent } from './vrsta-komitenta/vrsta-komitenta-update.component';
import { TarifaComponent } from './tarifa/tarifa.component';
import { TarifaModalUpdateComponent } from './tarifa/tarifa-modal-update.component';
import { TarifaUpdateComponent } from './tarifa/tarifa-update.component';
import { PodVrsteDokumentaComponent } from './podvrste-dokumenta/podvrste-dokumenta.component';
import { PodVrsteDokumentaModalUpdateComponent } from './podvrste-dokumenta/podvrste-dokumenta-modal-update.component';
import { PodVrsteDokumentaUpdateComponent } from './podvrste-dokumenta/podvrste-dokumenta-update.component';
import { StopaComponent } from './stopa/stopa.component';
import { StopaModalUpdateComponent } from './stopa/stopa-modal-update.component';
import { StopaUpdateComponent } from './stopa/stopa-update.component';
import { RobnaGrupaComponent } from './robna-grupa/robna-grupa.component';
import { RobnaGrupaModalUpdateComponent } from './robna-grupa/robna-grupa-modal-update.component';
import { RobnaGrupaUpdateComponent } from './robna-grupa/robna-grupa-update.component';
import { TreeviewModule } from 'ngx-treeview';
import { LanguageModalUpdateComponent } from './language/language-modal-update.component';
import { LanguageComponent } from './language/language.component';
import { LanguageUpdateComponent } from './language/language-update.component';
// import { NotifierService, NotifierModule } from 'angular-notifier';
import { TranslateModule } from '@ngx-translate/core';
import { BankaComponent } from './banka/banka.component';
import { BankaModalUpdateComponent } from './banka/banka-modal-update.component';
import { BankaUpdateComponent } from './banka/banka-update.component';
import { VrstaKontnogPlanaComponent } from './vrsta-kontnog-plana/vrsta-kontnog-plana.component';
import { VrstaKontnogPlanaModalUpdateComponent } from './vrsta-kontnog-plana/vrsta-kontnog-plana-modal-update.component';
import { VrstaKontnogPlanaUpdateComponent } from './vrsta-kontnog-plana/vrsta-kontnog-plana-update.component';
import { KontniPlanComponent } from './kontni-plan/kontni-plan.component';
import { KontniPlanModalUpdateComponent } from './kontni-plan/kontni-plan-modal-update.component';
import { KontniPlanUpdateComponent } from './kontni-plan/kontni-plan-update.component';
import { ValutaComponent } from './valuta/valuta.component';
import { ValutaModalUpdateComponent } from './valuta/valuta-modal-update.component';
import { ValutaUpdateComponent } from './valuta/valuta-update.component';
import { DrzavaComponent } from './drzava/drzava.component';
import { NacijaModalUpdateComponent } from './nacija/nacija-modal-update.component';
import { NacijaUpdateComponent } from './nacija/nacija-update.component';
import { NacijaComponent } from './nacija/nacija.component';
import { BracniStatusModalUpdateComponent } from './bracni-status/bracni-status-modal-update.component';
import { BracniStatusUpdateComponent } from './bracni-status/bracni-status-update.component';
import { BracniStatusComponent } from './bracni-status/bracni-status.component';
import { SvojinaComponent } from './svojina/svojina.component';
import { SvojinaModalUpdateComponent } from './svojina/svojina-modal-update.component';
import { SvojinaUpdateComponent } from './svojina/svojina-update.component';
import { MesnaZajednicaModalUpdateComponent } from './mesna-zajednica/mesna-zajednica-modal-update.component';
import { MesnaZajednicaUpdateComponent } from './mesna-zajednica/mesna-zajednica-update.component';
import { MesnaZajednicaComponent } from './mesna-zajednica/mesna-zajednica.component';
import { KalendarNeradnihDanaComponent } from './kalendar-neradnih-dana/kalendar-neradnih-dana.component';

import { OsobaComponent } from './osoba/osoba.component';
import { OsobaUpdateComponent } from './osoba/osoba-update.component';
import { OsobaModalUpdateComponent} from './osoba/osoba-modal-update.component';
import { OsobaTabsComponent } from './osoba/osoba-tabs.component';
import { OsobaTabUpdateComponent } from './osoba/osoba-tab-update.component';
import { OsobaTelefonUpdateComponent } from './osoba/osoba-telefon/osoba-telefon-update.component';
import { OsobaTelefonModalUpdateComponent } from './osoba/osoba-telefon/osoba-telefon-modal-update.component';
import { OsobaEmailUpdateComponent } from './osoba/osoba-email/osoba-email-update.component';
import { OsobaEmailModalUpdateComponent } from './osoba/osoba-email/osoba-email-modal-update.component';
import { OsobaSrodstvoUpdateComponent } from './osoba/osoba-srodstvo/osoba-srodstvo-update.component';
import { OsobaSrodstvoModalUpdateComponent } from './osoba/osoba-srodstvo/osoba-srodstvo-modal-update.component';
import { OsobaRadnaOpremaModalUpdateComponent } from './osoba/osoba-radna-oprema/osoba-radna-oprema-modal-update.component';
import { OsobaZnaJezikModalUpdateComponent } from './osoba/osoba-zna-jezik/osoba-zna-jezik-modal-update.component';
import { KomitentEmailModalUpdateComponent } from './komitent/komitent-email/komitent-email-modal-update.component';
import { KomitentTelefonModalUpdateComponent } from './komitent/komitent-telefon/komitent-telefon-modal-update.component';
import { KomitentZrcModalUpdateComponent } from './komitent/komitent-zrc/komitent-zrc-modal-update.component';
import { KomitentEmailUpdateComponent } from './komitent/komitent-email/komitent-email-update.component';
import { KomitentTelefonUpdateComponent } from './komitent/komitent-telefon/komitent-telefon-update.component';
import { KomitentZrcUpdateComponent } from './komitent/komitent-zrc/komitent-zrc-update.component';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { VrstaTelefonaModalUpdateComponent } from './vrsta-telefona/vrsta-telefona-modal-update.component';
import { VrstaTelefonaUpdateComponent } from './vrsta-telefona/vrsta-telefona-update.component';
import { VrstaTelefonaComponent } from './vrsta-telefona/vrsta-telefona.component';
import { PodVrsteDokumentaStavkaUpdateComponent } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-update.component';
import { PodVrsteDokumentaStavkaModalUpdateComponent } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka-modal-update.component';

import { PolUpdateComponent } from './pol/pol-update.component';
import { PolModalUpdateComponent } from './pol/pol-modal-update.component';
import { PolComponent } from './pol/pol.component';
import { OrgJedComponent } from './orgjed/orgjed.component';
import { OrgJedModalUpdateComponent } from './orgjed/orgjed-modal-update.component';
import { OrgJedUpdateComponent } from './orgjed/orgjed-update.component';

import { PodvrsteDokumentaStavkaComponent } from './podvrste-dokumenta-stavka/podvrste-dokumenta-stavka.component';
import { NacinPlacanjaComponent } from './nacin-placanja/nacin-placanja.component';
import { NacinPlacanjaModalUpdateComponent } from './nacin-placanja/nacin-placanja-modal-update.component';
import { NacinPlacanjaUpdateComponent } from './nacin-placanja/nacin-placanja-update.component';
import { OsobaZanimanjeUpdateComponent } from './osoba/osoba-zanimanje/osoba-zanimanje-update.component';
import { OsobaZanimanjeModalUpdateComponent } from './osoba/osoba-zanimanje/osoba-zanimanje-modal-update.component';

import { SrodstvoComponent } from './srodstvo/srodstvo.component';
import { SrodstvoModalUpdateComponent } from './srodstvo/srodstvo-modal-update.component';
import { SrodstvoUpdateComponent } from './srodstvo/srodstvo-update.component';
import { ZanimanjeModalUpdateComponent } from './zanimanje/zanimanje-modal-update.component';
import { ZanimanjeUpdateComponent } from './zanimanje/zanimanje-update.component';
import { ZanimanjeComponent } from './zanimanje/zanimanje.component';
import { OsobaZnaJezikUpdateComponent } from './osoba/osoba-zna-jezik/osoba-zna-jezik-update.component';
import { OsobaZanimanjeComponent } from './osoba/osoba-zanimanje/osoba-zanimanje.component';
import { OsobaRadnaOpremaUpdateComponent } from './osoba/osoba-radna-oprema/osoba-radna-oprema-update.component';
import { VrstaDokumentaUpdateComponent } from './vrsta-dokumenta/vrsta-dokumenta-update.component';
import { VrstaDokumentaComponent } from './vrsta-dokumenta/vrsta-dokumenta.component';
import { VrstaDokumentaModalUpdateComponent } from './vrsta-dokumenta/vrsta-dokumenta-modal-update.component';
import { TipRadneOpremeUpdateComponent } from './tip-radne-opreme/tip-radne-opreme-update.component';
import { TipRadneOpremeComponent } from './tip-radne-opreme/tip-radne-opreme.component';
import { TipRadneOpremeModalUpdateComponent } from './tip-radne-opreme/tip-radne-opreme-modal-update.component';
import { VelicinaSetComponent } from './velicina/velicina-set.component';
import { VelicinaSetUpdateComponent } from './velicina/velicina-set-update.component';
import { VelicinaSetModalUpdateComponent } from './velicina/velicina-set-modal-update.component';
import { VelicinaStavUpdateComponent } from './velicina/velicina-stav-update.component';
import { VelicinaStavModalUpdateComponent } from './velicina/velicina-stav-modal-update.component';
import { OsobaRadnaOpremaComponent } from './osoba/osoba-radna-oprema/osoba-radna-oprema.component';

import { KursDokumentTabsComponent } from './kurs-valuta/kurs-dokument-tabs.component';
import { KursDokumentStavkaInlineUpdateComponent } from './kurs-valuta/kurs-dokument-stavka-inline-update.component';
import { KursDokumentStavkaUpdateContainer } from './kurs-valuta/kurs-dokument-stavka-update-container.component';
import { KursDokumentUpdateComponent } from './kurs-valuta/kurs-dokument-update.component';
import { KursDokumentStavkaModalUpdateComponent } from './kurs-valuta/kurs-dokument-stavka-modal-update.component';
import { KursDokumentStavkaUpdateComponent } from './kurs-valuta/kurs-dokument-stavka-update.component';
import { KursDokumentTabUpdateComponent } from './kurs-valuta/kurs-dokument-tab-update.component';
import { OsobaSrodstvoComponent } from './osoba/osoba-srodstvo/osoba-srodstvo.component';
import { PageUpdateComponent } from './pageUpdateTest/page-update.component';
import { PageListComponent } from './pageUpdateTest/page-list.component';
import { ProizvodjacComponent } from './proizvodjac/proizvodjac.component';
import { ProizvodjacModalUpdateComponent } from './proizvodjac/proizvodjac-modal-update.component';
import { ProizvodjacUpdateComponent } from './proizvodjac/proizvodjac-update.component';
import { GotovinskiKomitentComponent } from './gotovinski-komitent/gotovinski-komitent.component';
import { GotovinskiKomitentUpdateComponent } from './gotovinski-komitent/gotovinski-komitent-update.component';
import { GotovinskiKomitentModalUpdateComponent } from './gotovinski-komitent/gotovinski-komitent-modal-update.component';
import { KalendarNeradnihDanaModalUpdateComponent } from './kalendar-neradnih-dana/kalendar-neradnih-dana-modal-update.component';
import { KalendarNeradnihDanaUpdateComponent } from './kalendar-neradnih-dana/kalendar-neradnih-dana-update.component';
import { EventService } from './kalendar-neradnih-dana/event.service';
import { KomitentObjekatComponent } from './komitent-objekat/komitent-objekat.component';
import { KomitentObjekatUpdateComponent } from './komitent-objekat/komitent-objekat-update.component';
import { KomitentObjekatModalUpdateComponent } from './komitent-objekat/komitent-objekat-modal-update.component';
import { PoreskoOslobodjenjeComponent } from './poresko-oslobodjenje/poresko-oslobodjenje.component';
import { PoreskoOslobodjenjeUpdateComponent } from './poresko-oslobodjenje/poresko-oslobodjenje-update.component';
import { PoreskoOslobodjenjeModalUpdateComponent } from './poresko-oslobodjenje/poresko-oslobodjenje-modal-update.component';
import { KomitentUvozNbsComponent } from './komitent/komitent-uvoz-nbs/komitent-uvoz-nbs.component';
import { PosaoComponent } from './posao/posao.component';
import { PosaoUpdateComponent } from './posao/posao-update.component';
import { PosaoModalUpdateComponent } from './posao/posao-modal-update.component';
import { RadnoMestoComponent } from './radno-mesto/radno-mesto.component';
import { RadnoMestoUpdateComponent } from './radno-mesto/radno-mesto-update.component';
import { RadnoMestoModalUpdateComponent } from './radno-mesto/radno-mesto-modal-update.component';
import { RadnoMestoPosloviComponent } from './radno-mesto/radno-mesto-poslovi.component';
import { RadnoMestoPosloviUpdateComponent } from './radno-mesto/radno-mesto-poslovi-update.component';
import { RadnoMestoPosloviTabsComponent } from './radno-mesto/radno-mesto-poslovi-tabs.component';
import { RadnoMestoPosloviTabUpdateComponent } from './radno-mesto/radno-mesto-poslovi-tab-update.component';
import { RadnoMestoPosloviStavkaUpdateComponent } from './radno-mesto/radno-mesto-poslovi-stavka-update.component';
import { RadnoMestoPosloviStavkaUpdateContainerComponent } from './radno-mesto/radno-mesto-poslovi-stavka-update-container.component';
import { RadnoMestoPosloviStavkaInlineUpdateComponent } from './radno-mesto/radno-mesto-poslovi-stavka-inline-update.component';
import { SpremaComponent } from './sprema/sprema.component';
import { SpremaUpdateComponent } from './sprema/sprema-update.component';
import { SpremaModalUpdateComponent } from './sprema/sprema-modal-update.component';
import { VrstaIzostankaComponent } from './vrsta-izostanka/vrsta-izostanka.component';
import { VrstaIzostankaUpdateComponent } from './vrsta-izostanka/vrsta-izostanka-update.component';
import { VrstaIzostankaModalUpdateComponent } from './vrsta-izostanka/vrsta-izostanka-modal-update.component';
import { KomitentObjekatUpisnoMestoComponent } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto.component';
import { KomitentObjekatUpisnoMestoModalUpdateComponent } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto-modal-update.component';
import { KomitentObjekatUpisnoMestoUpdateComponent } from './komitent-objekat-upisno-mesto/komitent-objekat-upisno-mesto-update.component';
import { KomitentVoziloComponent } from './komitent-vozilo/komitent-vozilo.component';
import { KomitentVoziloModalUpdateComponent } from './komitent-vozilo/komitent-vozilo-modal-update.component';
import { KomitentVoziloUpdateComponent } from './komitent-vozilo/komitent-vozilo-update.component';
import { KomitentUgovorUpdateComponent } from './komitent-ugovor/komitent-ugovor-update.component';
import { KomitentUgovorTabsComponent } from './komitent-ugovor/komitent-ugovor-tabs.component';
import { KomitentUgovorTabUpdateComponent } from './komitent-ugovor/komitent-ugovor-tab-update.component';
import { KomitentUgovorStavkaUpdateComponent } from './komitent-ugovor/komitent-ugovor-stavka-update.component';
import { KomitentUgovorStavkaUpdateContainerComponent } from './komitent-ugovor/komitent-ugovor-stavka-update-container.component';
import { KomitentUgovorStavkaInlineUpdateComponent } from './komitent-ugovor/komitent-ugovor-stavka-inline-update.component';
import { CommentComponent } from './_forme/comment/comment.component';
import { KomitentKontaktOsobaComponent } from './komitent-kontakt-osoba/komitent-kontakt-osoba.component';
import { KomitentKontaktOsobaUpdateComponent } from './komitent-kontakt-osoba/komitent-kontakt-osoba-update.component';
import { KomitentKontaktOsobaModalUpdateComponent } from './komitent-kontakt-osoba/komitent-kontakt-osoba-modal-update.component';
import { FirmaKodKupcaComponent } from './komitent/firma-kod-kupca/firma-kod-kupca.component';
import { IzmeniKomitentaComponent } from './_forme/izmeni-komitenta/izmeni-komitenta.component';
import { KomitentUpdateFromNbsComponent } from './komitent/komitent-update-from-nbs/komitent-update-from-nbs.component';
import { VrstaVozilaComponent } from './vrsta-vozila/vrsta-vozila.component';
import { VoziloComponent } from './vozilo/vozilo.component';
import { VrstaVozilaUpdateComponent } from './vrsta-vozila/vrsta-vozila-update.component';
import { VrstaVozilaModalUpdateComponent } from './vrsta-vozila/vrsta-vozila-modal-update.component';
import { VoziloModalUpdateComponent } from './vozilo/vozilo-modal-update.component';
import { VoziloUpdateComponent } from './vozilo/vozilo-update.component';
import { UplataComponent } from './_forme/uplata/uplata.component';
import { AkciznaRobaComponent } from './akcizna-roba/akcizna-roba.component';
import { AkciznaRobaTipPakovanjaComponent } from './akcizna-roba-tip-pakovanja/akcizna-roba-tip-pakovanja.component';


@NgModule({
  imports: [
    CommonModule,
    YtNgFrameworkModule,
    FormsModule
    , ReactiveFormsModule
    , TreeviewModule.forRoot(),
    //NotifierModule
    TranslateModule
    ,NgbModule
  ],
  declarations: [DrzavaComponent, DrzavaModalUpdateComponent, DrzavaUpdateComponent
    , RobaComponent, RobaModalUpdateComponent, RobaUpdateComponent, PosaoComponent, PosaoUpdateComponent 
    , PosaoModalUpdateComponent, JedinicaMereComponent, JedinicaMereModalUpdateComponent, JedinicaMereUpdateComponent
    , KomitentComponent, KomitentModalUpdateComponent, KomitentUpdateComponent, KomitentTabsComponent, KomitentTabUpdateComponent
    , MagacinComponent, MagacinModalUpdateComponent, MagacinUpdateComponent
    , MestoComponent, MestoModalUpdateComponent, MestoUpdateComponent
    , OkrugComponent, OkrugModalUpdateComponent, OkrugUpdateComponent
    , OpstinaComponent, OpstinaModalUpdateComponent, OpstinaUpdateComponent
    , TipKomitentaComponent, TipKomitentaModalUpdateComponent, TipKomitentaUpdateComponent
    , VrstaKomitentaComponent, VrstaKomitentaModalUpdateComponent, VrstaKomitentaUpdateComponent
    , TarifaComponent, TarifaModalUpdateComponent, TarifaUpdateComponent
    , PodVrsteDokumentaComponent, PodVrsteDokumentaModalUpdateComponent, PodVrsteDokumentaUpdateComponent
    , StopaComponent, StopaModalUpdateComponent, StopaUpdateComponent
    , RobnaGrupaComponent, RobnaGrupaModalUpdateComponent, RobnaGrupaUpdateComponent
    , LanguageModalUpdateComponent, LanguageComponent, LanguageUpdateComponent
    , BankaComponent, BankaModalUpdateComponent, BankaUpdateComponent
    , AkciznaRobaComponent
    , AkciznaRobaTipPakovanjaComponent
    , VrstaKontnogPlanaComponent, VrstaKontnogPlanaModalUpdateComponent, VrstaKontnogPlanaUpdateComponent
    , KontniPlanComponent, KontniPlanModalUpdateComponent, KontniPlanUpdateComponent
    , ValutaComponent, ValutaModalUpdateComponent, ValutaUpdateComponent
    , NacijaModalUpdateComponent, NacijaUpdateComponent, NacijaComponent
    , BracniStatusModalUpdateComponent, BracniStatusUpdateComponent, BracniStatusComponent
    , SvojinaComponent, SvojinaModalUpdateComponent, SvojinaUpdateComponent
    , MesnaZajednicaModalUpdateComponent, MesnaZajednicaUpdateComponent, MesnaZajednicaComponent
    , KalendarNeradnihDanaComponent
    , OsobaComponent, OsobaUpdateComponent, OsobaModalUpdateComponent, OsobaTabsComponent, OsobaTabUpdateComponent
    , KomitentEmailModalUpdateComponent, KomitentTelefonModalUpdateComponent, KomitentZrcModalUpdateComponent
    , KomitentEmailUpdateComponent, KomitentTelefonUpdateComponent, KomitentZrcUpdateComponent
    , VrstaTelefonaModalUpdateComponent, VrstaTelefonaUpdateComponent, VrstaTelefonaComponent
    , KalendarNeradnihDanaComponent
    , PolUpdateComponent, PolModalUpdateComponent, PolComponent, LookupsComponent
    , OrgJedComponent, OrgJedUpdateComponent, OrgJedModalUpdateComponent
    , PodvrsteDokumentaStavkaComponent, PodVrsteDokumentaStavkaModalUpdateComponent, PodVrsteDokumentaStavkaUpdateComponent
    , NacinPlacanjaComponent, NacinPlacanjaModalUpdateComponent, NacinPlacanjaUpdateComponent
    , OsobaTelefonUpdateComponent, OsobaTelefonModalUpdateComponent
    , OsobaEmailUpdateComponent, OsobaEmailModalUpdateComponent
    , OsobaSrodstvoUpdateComponent, OsobaSrodstvoModalUpdateComponent
    , OsobaZanimanjeUpdateComponent, OsobaZanimanjeModalUpdateComponent
    , SrodstvoComponent, SrodstvoModalUpdateComponent, SrodstvoUpdateComponent
    , ZanimanjeModalUpdateComponent, ZanimanjeComponent, ZanimanjeUpdateComponent
    , OsobaZnaJezikModalUpdateComponent, OsobaZnaJezikUpdateComponent
    , OsobaZanimanjeComponent
    , VrstaDokumentaComponent, VrstaDokumentaModalUpdateComponent, VrstaDokumentaUpdateComponent
    , TipRadneOpremeComponent, TipRadneOpremeUpdateComponent, TipRadneOpremeModalUpdateComponent
    , VelicinaSetComponent, VelicinaSetUpdateComponent, VelicinaSetModalUpdateComponent
    , VelicinaStavUpdateComponent, VelicinaStavModalUpdateComponent
    , OsobaRadnaOpremaUpdateComponent, OsobaRadnaOpremaModalUpdateComponent, OsobaRadnaOpremaComponent
    , KursDokumentUpdateComponent, KursDokumentTabUpdateComponent, KursDokumentTabsComponent
    , KursDokumentStavkaUpdateComponent, KursDokumentStavkaModalUpdateComponent, KursDokumentStavkaUpdateContainer
    , KursDokumentStavkaInlineUpdateComponent
    , OsobaSrodstvoModalUpdateComponent, OsobaSrodstvoUpdateComponent, OsobaSrodstvoComponent ,
    PageUpdateComponent, PageListComponent,
    DefaultFilter,
    ProizvodjacComponent, ProizvodjacModalUpdateComponent, ProizvodjacUpdateComponent
    , GotovinskiKomitentComponent, GotovinskiKomitentUpdateComponent, GotovinskiKomitentModalUpdateComponent
    , KalendarNeradnihDanaComponent, KalendarNeradnihDanaModalUpdateComponent, KalendarNeradnihDanaUpdateComponent
    , KomitentObjekatComponent, KomitentObjekatUpdateComponent, KomitentObjekatModalUpdateComponent
    , SpremaComponent, SpremaUpdateComponent, SpremaModalUpdateComponent
    , PoreskoOslobodjenjeComponent, PoreskoOslobodjenjeUpdateComponent, PoreskoOslobodjenjeModalUpdateComponent
    , KomitentUvozNbsComponent, RadnoMestoPosloviComponent
    , RadnoMestoPosloviUpdateComponent, RadnoMestoPosloviTabsComponent
    , RadnoMestoPosloviTabUpdateComponent, RadnoMestoPosloviStavkaUpdateComponent
    , RadnoMestoPosloviStavkaUpdateContainerComponent, RadnoMestoPosloviStavkaInlineUpdateComponent, RadnoMestoComponent, RadnoMestoUpdateComponent, RadnoMestoModalUpdateComponent
    , VrstaIzostankaComponent, VrstaIzostankaUpdateComponent, VrstaIzostankaModalUpdateComponent
    , KomitentObjekatUpisnoMestoComponent, KomitentObjekatUpisnoMestoModalUpdateComponent, KomitentObjekatUpisnoMestoUpdateComponent
    , KomitentVoziloComponent, KomitentVoziloModalUpdateComponent, KomitentVoziloUpdateComponent
    , KomitentUgovorUpdateComponent, KomitentUgovorTabsComponent, KomitentUgovorTabUpdateComponent, KomitentUgovorStavkaUpdateComponent, KomitentUgovorStavkaUpdateContainerComponent
    , KomitentUgovorStavkaInlineUpdateComponent
    , CommentComponent
    , KomitentKontaktOsobaComponent, KomitentKontaktOsobaUpdateComponent, KomitentKontaktOsobaModalUpdateComponent
    , FirmaKodKupcaComponent, IzmeniKomitentaComponent, KomitentUpdateFromNbsComponent
    , VrstaVozilaComponent
    , VoziloComponent
    , VrstaVozilaUpdateComponent
    , VrstaVozilaModalUpdateComponent
    , VoziloModalUpdateComponent
    , VoziloUpdateComponent
    , UplataComponent
    ],
  exports: [DrzavaComponent, DrzavaModalUpdateComponent, DrzavaUpdateComponent
    , RobaComponent, RobaModalUpdateComponent, RobaUpdateComponent, PosaoComponent, PosaoUpdateComponent 
    , PosaoModalUpdateComponent, JedinicaMereComponent, JedinicaMereModalUpdateComponent, JedinicaMereUpdateComponent
    , KomitentComponent, KomitentModalUpdateComponent, KomitentUpdateComponent
    , MagacinComponent, MagacinModalUpdateComponent, MagacinUpdateComponent 
    , MestoComponent, MestoModalUpdateComponent, MestoUpdateComponent
    , OkrugComponent, OkrugModalUpdateComponent, OkrugUpdateComponent
    , OpstinaComponent, OpstinaModalUpdateComponent, OpstinaUpdateComponent
    , TipKomitentaModalUpdateComponent, TipKomitentaUpdateComponent
    , VrstaKomitentaComponent, VrstaKomitentaModalUpdateComponent, VrstaKomitentaUpdateComponent
    , TarifaComponent, TarifaModalUpdateComponent, TarifaUpdateComponent
    , PodVrsteDokumentaComponent, PodVrsteDokumentaModalUpdateComponent, PodVrsteDokumentaUpdateComponent
    , StopaComponent, StopaModalUpdateComponent, StopaUpdateComponent
    , RobnaGrupaComponent, RobnaGrupaModalUpdateComponent, RobnaGrupaUpdateComponent
    , LanguageModalUpdateComponent, LanguageComponent, LanguageUpdateComponent
    , BankaComponent, BankaModalUpdateComponent, BankaUpdateComponent
    , VrstaKontnogPlanaComponent, VrstaKontnogPlanaModalUpdateComponent, VrstaKontnogPlanaUpdateComponent
    , KontniPlanComponent, KontniPlanModalUpdateComponent, KontniPlanUpdateComponent
    , ValutaComponent, ValutaModalUpdateComponent, ValutaUpdateComponent
    , BracniStatusModalUpdateComponent, BracniStatusUpdateComponent, BracniStatusComponent
    , NacijaModalUpdateComponent, NacijaUpdateComponent, NacijaComponent
    , SvojinaComponent, SvojinaModalUpdateComponent, SvojinaUpdateComponent
    , CommonModule, YtNgFrameworkModule, FormsModule, ReactiveFormsModule
    , OsobaUpdateComponent, OsobaComponent, OsobaModalUpdateComponent, OsobaTabUpdateComponent, OsobaTabsComponent
    , KomitentEmailModalUpdateComponent, KomitentTelefonModalUpdateComponent, KomitentZrcModalUpdateComponent
    , KomitentEmailUpdateComponent, KomitentTelefonUpdateComponent, KomitentZrcUpdateComponent
    , VrstaTelefonaModalUpdateComponent, VrstaTelefonaUpdateComponent, VrstaTelefonaComponent
    , OrgJedComponent, OrgJedUpdateComponent, OrgJedModalUpdateComponent
    , NacinPlacanjaModalUpdateComponent, NacinPlacanjaUpdateComponent, NacinPlacanjaComponent
    , OsobaTelefonUpdateComponent, OsobaTelefonModalUpdateComponent
    , OsobaEmailUpdateComponent, OsobaEmailModalUpdateComponent
    , OsobaSrodstvoUpdateComponent, OsobaSrodstvoModalUpdateComponent
    , OsobaZanimanjeUpdateComponent, OsobaZanimanjeModalUpdateComponent
    , SrodstvoComponent, SrodstvoUpdateComponent
    , SpremaComponent, SpremaUpdateComponent
    , ZanimanjeModalUpdateComponent, ZanimanjeComponent, ZanimanjeUpdateComponent
    , OsobaZnaJezikModalUpdateComponent, OsobaZnaJezikUpdateComponent
    , VrstaDokumentaComponent, VrstaDokumentaModalUpdateComponent, VrstaDokumentaUpdateComponent
    , TipRadneOpremeComponent, TipRadneOpremeUpdateComponent, TipRadneOpremeModalUpdateComponent
    , VelicinaSetComponent, VelicinaSetUpdateComponent, VelicinaSetModalUpdateComponent    
    , VelicinaStavUpdateComponent, VelicinaStavModalUpdateComponent   
    , OsobaRadnaOpremaUpdateComponent, OsobaRadnaOpremaModalUpdateComponent, OsobaRadnaOpremaComponent 
    , KursDokumentTabsComponent, KursDokumentUpdateComponent, KursDokumentStavkaUpdateComponent
    , OsobaSrodstvoModalUpdateComponent, OsobaSrodstvoUpdateComponent, OsobaSrodstvoComponent, DefaultFilter
    , ProizvodjacModalUpdateComponent, ProizvodjacUpdateComponent, ProizvodjacComponent
    , GotovinskiKomitentComponent, GotovinskiKomitentUpdateComponent, GotovinskiKomitentModalUpdateComponent
    , KalendarNeradnihDanaComponent, KalendarNeradnihDanaModalUpdateComponent, KalendarNeradnihDanaUpdateComponent
    , KomitentObjekatComponent, KomitentObjekatUpdateComponent, KomitentObjekatModalUpdateComponent
    , PoreskoOslobodjenjeComponent, PoreskoOslobodjenjeUpdateComponent, PoreskoOslobodjenjeModalUpdateComponent
    , KomitentObjekatUpisnoMestoComponent, KomitentObjekatUpisnoMestoUpdateComponent, KomitentObjekatUpisnoMestoModalUpdateComponent
    , KomitentVoziloComponent, KomitentVoziloUpdateComponent, KomitentVoziloModalUpdateComponent
    , CommentComponent
    , KomitentKontaktOsobaComponent, KomitentKontaktOsobaUpdateComponent, KomitentKontaktOsobaModalUpdateComponent
    , FirmaKodKupcaComponent
    , IzmeniKomitentaComponent
    , VrstaVozilaComponent
    , VoziloComponent
    , VrstaVozilaUpdateComponent
    , VrstaVozilaModalUpdateComponent
    , VoziloModalUpdateComponent
    , VoziloUpdateComponent
    , UplataComponent
  ] ,
  providers:[
    //NotifierService
    EventService,
    ModalService
  ],
  // entryComponents:[
  //   KomitentUvozNbsComponent
  // , SpremaModalUpdateComponent
  // , CommentComponent
  // , FirmaKodKupcaComponent
  // , KomitentUpdateFromNbsComponent
  // , IzmeniKomitentaComponent
  // , KomitentZrcModalUpdateComponent
  // , KomitentEmailModalUpdateComponent
  // , KomitentTelefonModalUpdateComponent
  // , KomitentKontaktOsobaModalUpdateComponent
  // , KomitentObjekatUpisnoMestoModalUpdateComponent
  // , KomitentObjekatModalUpdateComponent
  // , RadnoMestoModalUpdateComponent
  // , TipRadneOpremeModalUpdateComponent
  // , ZanimanjeModalUpdateComponent
  // , VrstaIzostankaModalUpdateComponent
  // , ProizvodjacModalUpdateComponent
  // , GotovinskiKomitentModalUpdateComponent
  // , SrodstvoModalUpdateComponent
  // , NacijaModalUpdateComponent
  // , BracniStatusModalUpdateComponent
  // , PolModalUpdateComponent
  // , VrstaDokumentaModalUpdateComponent
  // , PodVrsteDokumentaStavkaModalUpdateComponent
  // , BankaModalUpdateComponent
  // , VrstaKontnogPlanaModalUpdateComponent
  // , KontniPlanModalUpdateComponent
  // , ValutaModalUpdateComponent
  // , SvojinaModalUpdateComponent
  // , VrstaTelefonaModalUpdateComponent
  // , OrgJedModalUpdateComponent
  // , VelicinaSetModalUpdateComponent
  // , VelicinaStavModalUpdateComponent
  // , PoreskoOslobodjenjeModalUpdateComponent
  // , MesnaZajednicaModalUpdateComponent
  // , OsobaEmailModalUpdateComponent
  // , OsobaTelefonModalUpdateComponent
  // , OsobaModalUpdateComponent
  // , VoziloModalUpdateComponent
  // , VrstaVozilaModalUpdateComponent
  // , UplataComponent
  // ]
})
export class LookupsModule { }
